module.exports = __webpack_public_path__ + "static/img/logo-ymzs.16356f04.png";